<script lang="ts">
    import PortfoliosPage from '@Quest/Portfolios/Pages/PortfoliosPage'
    export default PortfoliosPage
</script>

<template>
    <div>
        <div class="modal-mask" v-if="portfolioLinker.opened">
            <div class="modal-wrapper">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Link portfolio</h5>
                            <button @click="closePortfolioLinker" type="button" class="close">&times;</button>
                        </div>

                        <div class="modal-body">
                            <div class="form-group">
                                <label>Workspace:</label>
                                <select v-model="portfolioLinker.workspaceId" class="form-control">
                                    <option v-for="w in rm.Workspaces" :value="w.WorkspaceId">{{w.Name}}</option>
                                </select>
                            </div>
                            <div class="form-group" v-if="tchProjects != null">
                                <label>Portfolio:</label>
                                <select v-model="portfolioLinker.tchProjectId" class="form-control">
                                    <option v-for="p in tchProjects" :value="p.Id">{{p.Name}}</option>
                                </select>
                            </div>
                        </div>

                        <div class="modal-footer">
                            <button @click="handleLinkPortfolioCommand" type="button" class="btn btn-primary" :enabled="portfolioLinker.canSave">Link</button>
                            <button @click="closePortfolioLinker" type="button" class="btn btn-outline-secondary">Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <PortfolioCreatorDialog :viewModel="portfolioCreatorDialog"
                                @create-portfolio="handleCreatePortfolioCommand"/>


        <CorporateNavigation ActivePage="portfolios" />


        <div v-if="rm" class="container" style="margin-top: 80px; padding-top: 40px;">
            <div class="row">
                <div class="col-lg-6">
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b; margin: 0;">Portfolios</h1>
                </div>
                <div class="col-lg-6 text-right align-self-end">

                    <div class="btn-group">
                        <button role="button" class="btn btn-success" style="padding: 0.7em 2em;" @click="showPortfolioCreator">Create portfolio</button>
                        <button type="button" class="btn btn-outline-success dropdown-toggle dropdown-toggle-split" data-toggle="dropdown">
                            <span class="sr-only">Toggle Dropdown</span>
                        </button>
                        <div class="dropdown-menu dropdown-menu-right">
                            <a class="dropdown-item" @click="showPortfolioLinker">Link existing portfolio</a>
                        </div>
                    </div>
                </div>
            </div>

            <hr style="border-color: #bbb; margin: 20px 0 60px;" />

            <div class="mt-3">
                <table class="table table-bordered table-hover">
                    <thead>
                        <tr>
                            <th>Portfolio</th>
                            <th style="width: 120px;"></th>
                        </tr>

                    </thead>
                    <tbody>
                        <tr v-for="p in validPortfolios" :key="p.Id">
                            <td>
                                <a v-sanitizedHref="`/#/portfolio/kanban/${p.WorkspaceId}/${p.TchProjectId}`">{{p.Name}}</a><br />
                                <small class="text-muted">Workspace: {{p.WorkspaceName}}</small>
                            </td>
                            <td>
                                <div class="dropdown">
                                    <button type="button" class="btn btn-outline-secondary dropdown-toggle" data-toggle="dropdown">
                                        Actions
                                    </button>
                                    <div class="dropdown-menu dropdown-menu-right">
                                        <a class="dropdown-item" v-sanitizedHref="`/#/portfolio/settings/${workspaceId}/${p.TchProjectId}`">Settings</a>
                                        <div class="dropdown-divider"></div>
                                        <a class="dropdown-item" @click="handleDeletePortfolioCommand(p)">Delete</a>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr v-for="p in invalidPortfolios" :key="p.Id" class="table-danger">
                            <td>{{p.Name}}</td>
                            <td>
                                <button type="button" class="btn btn-outline-secondary" @click="handleDeletePortfolioCommand(p)">
                                    Delete
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>